<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.interview_context"
          label-for="timeing"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.interview_context"
            :rules="$v.person_license_type_selected.$params"
          />
          <selectFind
            :options="person_license_type_options"
            v-model="$v.person_license_type_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.person_license_type_selected.$dirty
                ? !$v.person_license_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.person_license_type_selected.$error
                ? 'block'
                : 'none',
            }"
            id="person_license_type_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.interview_context) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.interview_field"
          label-for="person_license_grade"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.interview_field"
            :rules="$v.person_license_grade_selected.$params"
          />
          <selectFind
            :options="person_license_grade_options"
            v-model="$v.person_license_grade_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.person_license_grade_selected.$dirty
                ? !$v.person_license_grade_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.person_license_grade_selected.$error
                ? 'block'
                : 'none',
            }"
            id="person_license_grade_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.interview_field) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.question_description"
          label-for="question_description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.question_description"
            :rules="$v.question_description.$params"
          />
          <b-form-textarea
            id="question_description"
            v-model="$v.question_description.$model"
            :state="
              $v.question_description.$dirty
                ? !$v.question_description.$error
                : null
            "
            type="text"
            :autocomplete="$lang.question_description"
            rows="4"
          ></b-form-textarea>

          <b-form-invalid-feedback id="question_description-feedback">
            {{ $lang.error_required | replace($lang.question_description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.answer_description"
          label-for="answer_description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.answer_description"
            :rules="$v.answer_description.$params"
          />
          <b-form-textarea
            id="answer_description"
            v-model="$v.answer_description.$model"
            :state="
              $v.answer_description.$dirty
                ? !$v.answer_description.$error
                : null
            "
            type="text"
            :autocomplete="$lang.answer_description"
            rows="4"
          ></b-form-textarea>

          <b-form-invalid-feedback id="answer_description-feedback">
            {{ $lang.error_required | replace($lang.answer_description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.question_suggest_level"
          label-for="question_suggest_level"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.question_suggest_level"
            :rules="$v.question_suggest_level_selected.$params"
          />
          <selectFind
            :options="question_suggest_level_options"
            v-model="$v.question_suggest_level_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.question_suggest_level_selected.$dirty
                ? !$v.question_suggest_level_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.question_suggest_level_selected.$error
                ? 'block'
                : 'none',
            }"
            id="question_suggest_level_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.question_suggest_level) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.question_suggest_type"
          label-for="question_suggest_type"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.question_suggest_type"
            :rules="$v.question_suggest_type_selected.$params"
          />
          <selectFind
            :options="question_suggest_type_options"
            v-model="$v.question_suggest_type_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.question_suggest_type_selected.$dirty
                ? !$v.question_suggest_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.question_suggest_type_selected.$error
                ? 'block'
                : 'none',
            }"
            id="question_suggest_type_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.question_suggest_type) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        v-if="
          checkPermission(['modir_system', 'ostad_arshad_mosahebeh'], roles) &&
          mode == `edit`
        "
      >
        <b-form-group
          :label="$lang.question_suggest_quality_evaluation"
          label-for="question_suggest_quality_evaluation"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.question_suggest_quality_evaluation"
            :rules="$v.question_suggest_quality_evaluation_selected.$params"
          />
          <selectFind
            :options="question_suggest_quality_evaluation_options"
            v-model="$v.question_suggest_quality_evaluation_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.question_suggest_quality_evaluation_selected.$dirty
                ? !$v.question_suggest_quality_evaluation_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.question_suggest_quality_evaluation_selected.$error
                ? 'block'
                : 'none',
            }"
            id="question_suggest_quality_evaluation_selected_feedback"
          >
            {{
              $lang.error_required
                | replace($lang.question_suggest_quality_evaluation)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        v-if="
          checkPermission(['modir_system', 'ostad_arshad_mosahebeh'], roles) &&
          mode == `edit`
        "
      >
        <b-form-checkbox
          id="is_confirmed"
          v-model="is_confirmed"
          name="is_confirmed"
          value="1"
          unchecked-value="0"
        >
          {{ $lang.is_confirmed }}
          <span
            key="fa-info-circle"
            v-b-tooltip.hover
            :title="$lang.is_confirmed_tooltip"
          >
            <i class="fa fa-info-circle fa-lg text-info"></i>
          </span>
        </b-form-checkbox>
      </b-col>
      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <b-button
            v-if="
              checkPermission(['modir_system', 'modir_omoor_asatid'], roles)
            "
            @click="patchQuestionSuggest"
            class="text-center mr-2"
            variant="info"
            :disabled="isBtnLoading"
          >
            <div v-if="!isBtnLoading">
              {{ $lang.question_use }}
              <span key="fa-check"><i class="fa fa-check"></i></span>
            </div>
            <div v-if="isBtnLoading">
              <b-spinner small></b-spinner>
              <span> {{ $lang.search.loading_send }}</span>
            </div>
          </b-button>
          <b-button
            @click="submit"
            v-if="checkPermission(permissions, ['admin', 'edit'])"
            type="submit"
            size="md"
            variant="success"
          >
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions, checkPermission } from "@/shared/utils";
import { pathOr, pick } from "ramda";
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    person_license_type_selected: { required },
    person_license_grade_selected: { required },
    question_description: { required },
    answer_description: { required },
    question_suggest_level_selected: { required },
    question_suggest_type_selected: { required },
    question_suggest_quality_evaluation_selected: {},
  },
  props: {
    item: {
      type: Object,
      defualt: () => {},
    },
    permissions: {
      type: Array,
      defualt: () => [],
    },
    mode: {
      type: String,
      defualt: "",
    },
  },
  data() {
    return {
      is_confirmed: 0,
      roles: [],
      person_license_type_selected: null,
      isBtnLoading: false,
      id: this.$route.params.id,
      person_license_grade_selected: null,
      question_suggest_level_selected: null,
      question_suggest_type_selected: null,
      question_description: null,
      answer_description: null,
      question_suggest_quality_evaluation_selected: null,
    };
  },
  computed: {
    person_license_type_options() {
      return renderEumOptions("interview_context");
    },
    question_suggest_level_options() {
      return renderEumOptions("question_suggest_level");
    },
    question_suggest_type_options() {
      return renderEumOptions("question_suggest_type");
    },
    question_suggest_quality_evaluation_options() {
      return renderEumOptions("question_suggest_quality_evaluation");
    },
    person_license_grade_options() {
      return renderEumOptions("person_license_grade");
    },
  },
  methods: {
    checkPermission,
    async patchQuestionSuggest() {
      try {
        this.isBtnLoading = true;
        const url =
          this.$config.api_url +
          this.$config.interview.question_suggest_id.replace("{0}", this.id);
        const response = await this.$httpService.patch(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isBtnLoading = false;
      }
    },
    cancel() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        person_license_type_id: pathOr(
          null,
          ["value"],
          this.person_license_type_selected
        ),
        person_license_grade_id: pathOr(
          null,
          ["value"],
          this.person_license_grade_selected
        ),
        question_description: this.question_description,
        answer_description: this.answer_description,
        question_suggest_level_id: pathOr(
          null,
          ["value"],
          this.question_suggest_level_selected
        ),
        question_suggest_type_id: pathOr(
          null,
          ["value"],
          this.question_suggest_type_selected
        ),
        question_suggest_quality_evaluation_id: pathOr(
          null,
          ["value"],
          this.question_suggest_quality_evaluation_selected
        ),
        is_confirmed: this.is_confirmed,
      };
      if (!checkPermission(["admin"], this.permissions)) {
        payload = {
          ...pick(
            [
              "person_license_type_id",
              "person_license_grade_id",
              "question_description",
              "answer_description",
              "question_suggest_level_id",
              "question_suggest_type_id",
            ],
            payload
          ),
        };
      }
      this.$emit("submit", payload);
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.person_license_type_selected =
          this.person_license_type_options.find(
            (x) =>
              x.value === pathOr(null, ["person_license_type", "id"], this.item)
          );
        this.person_license_grade_selected =
          this.person_license_grade_options.find(
            (x) =>
              x.value ===
              pathOr(null, ["person_license_grade", "id"], this.item)
          );

        this.question_description = this.item && this.item.question_description;
        this.answer_description = this.item && this.item.answer_description;

        this.question_suggest_level_selected =
          this.question_suggest_level_options.find(
            (x) =>
              x.value ===
              pathOr(null, ["question_suggest_level", "id"], this.item)
          );

        this.question_suggest_type_selected =
          this.question_suggest_type_options.find(
            (x) =>
              x.value ===
              pathOr(null, ["question_suggest_type", "id"], this.item)
          );

        this.question_suggest_quality_evaluation_selected =
          this.question_suggest_quality_evaluation_options.find(
            (x) =>
              x.value ===
              pathOr(
                null,
                ["question_suggest_quality_evaluation", "id"],
                this.item
              )
          );

        this.is_confirmed = this.item.is_confirmed;
      }
      this.roles =
        this.$store.state.profile.userInfo &&
        this.$store.state.profile.userInfo.roles;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
